import { type Ref } from 'react';
import { Button } from '@zep-us/zus';
import { Violet500 } from '@zep-us/zus/tokens';
import { BookFillIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { BetaChip } from '@/shared/components/Chip/BetaChip';
interface QuizBankEntryRowUIProps {
  /** 빌드 폼 문제 상한에 닿았다 — 버튼은 남기되 누를 수 없다 */
  isFull: boolean;
  limit: number;
  /**
   * 노출 관측용 ref. 트래킹은 `QuizBankEntryRow` 가 소유한다 — 유저 문맥이 실린 뒤에
   * 관측을 **시작**해야 해서, 관측 시작 시점을 표현부가 정할 수 없다.
   */
  rootRef?: Ref<HTMLDivElement>;
  onOpen: () => void;
}

/**
 * 재진입 진입점의 표현부. AI 버튼 그리드에 섞지 않고 전용 행으로 둔다 —
 * 조건부로 나타나고 사라져서 그리드에 넣으면 다른 버튼이 좌우로 움직인다.
 */
export const QuizBankEntryRowUI = ({
  isFull,
  limit,
  rootRef,
  onOpen
}: QuizBankEntryRowUIProps) => {
  const {
    t
  } = useTranslation(['build']);
  return <div ref={rootRef} className="border-1 mb-lg flex w-full flex-col gap-sm rounded-md border-assistive bg-default px-md py-lg shadow-xs tablet-sm:flex-row tablet-sm:items-center tablet-sm:justify-between tablet-sm:px-lg" data-sentry-component="QuizBankEntryRowUI" data-sentry-source-file="QuizBankEntryRowUI.tsx">
      <div className="flex min-w-0 items-start gap-xs">
        <BookFillIcon size="md" fill={Violet500} className="mt-4xs shrink-0" data-sentry-element="BookFillIcon" data-sentry-source-file="QuizBankEntryRowUI.tsx" />
        <div className="flex min-w-0 flex-col gap-4xs">
          <span className="flex items-center gap-xs text-body-lg-bold text-default">
            <span className="truncate">{t('build:quizBank.entry.title')}</span>
            <BetaChip className="shrink-0" data-sentry-element="BetaChip" data-sentry-source-file="QuizBankEntryRowUI.tsx" />
          </span>
          <span className="text-body-sm-medium text-alternative">
            {isFull ? t('build:quizBank.entry.full', {
            limit
          }) : t('build:quizBank.entry.description')}
          </span>
        </div>
      </div>

      <Button variant="outlined" intent="neutral" size="md" disabled={isFull} className="shrink-0" onClick={onOpen} data-sentry-element="Button" data-sentry-source-file="QuizBankEntryRowUI.tsx">
        {t('build:quizBank.entry.action')}
      </Button>
    </div>;
};